import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'Orders Pool |||| Orders Pools',
      fields: {
        id: 'ID',
      },
    }
  }
}